import { Component, EventEmitter, Input, OnInit, Output, Self, Optional, ViewChild, ElementRef, forwardRef, OnChanges } from '@angular/core';
import { ControlValueAccessor, NgControl, Validators } from '@angular/forms';

@Component({
  selector: 'rfr-input',
  templateUrl: './rfr-input.component.html',
  styleUrls: ['./rfr-input.component.scss'],
})
export class RfrInputComponent implements OnInit, ControlValueAccessor {
  @Input() id: string = ""
  @Input() type: string = 'text';
  @Input() alignInputText: 'center' | 'left' | 'right' = 'left';
  @Input() labelText: string = '';
  @Input() placeholder: string = '';
  @Input() pattern: string = '';
  @Input() required: boolean = false;
  @Input() readonly: boolean = false;
  @Input() error: boolean = false;
  @Input() errorMessage: string = '';
  @Input() min!: number;
  @Input() max!: number;
  @Input() maxLength: number = 250;
  @Input() class = "";
  @Input() style = "";
  @Input() size: 'normal' | 'large' = 'normal'; // Default value is 'normal'
  @Input() dotNumber: number = 2;
  @Input() iconName = '';
  @Output() blur: EventEmitter<void> = new EventEmitter<void>();

  displayValue: string = '';
  disabled!: boolean;
  onChange: (value: any) => void = () => { };
  onTouched: () => void = () => { };

  constructor(@Self() @Optional() public controlDir: NgControl) {
    if (this.controlDir) {
      this.controlDir.valueAccessor = this;
    }
  }

  ngOnInit(): void {
    if (this.controlDir) {
      const control = this.controlDir.control;
      if (this.required && control) {
        const validators = control.validator
          ? [control.validator, Validators.required]
          : Validators.required;

        control.setValidators(validators);
        control.updateValueAndValidity();
      }

      if (control?.value) {
        this.onBlur();
      }
    }
  }

  writeValue(value: any): void {
    this.displayValue = value;
  }


  registerOnChange(onChange: (value: any) => void): void {
    this.onChange = onChange;
  }

  registerOnTouched(onTouched: () => void): void {
    this.onTouched = onTouched;
  }

  setDisabledState(disabled: boolean): void {
    this.disabled = disabled;
  }

  onBlur(): void {
    if (this.type === 'currency') {
      if (this.displayValue && this.displayValue?.toString().includes(".") && this.displayValue) {
        const parts = this.displayValue.split(".");
        if (!parts[1] && this.displayValue) {
          this.displayValue = parts[0] + '.' + '00';
        } else if (parts[1]?.length == 1) {
          const rightPart = parts[1] + '0';
          this.displayValue = parts[0] + '.' + rightPart;
        }
      } else {
        if (this.displayValue)
          this.displayValue += '.00'
      }
    }

    this.onTouched();
    this.blur.emit();
  }

  onChangeInput(value: any): void {
    if (this.type === 'currency' || this.type === 'unit') {
      const numericValue = this.parseNumber(value);
      this.onChange(numericValue);
      this.displayValue = this.thousandSeparator(numericValue, ".");
    } else {
      this.onChange(value);
      this.displayValue = value;
    }
  }

  allowNumber(event: any) {

    if (this.type == 'number') {
      if (this.min > 0) {
        if (event.key === '-' || event.keyCode === 189) {
          event.target.value = event.target.value?.replaceAll('-', '');
          event.preventDefault();
        }
      }
    }
  }

  formatText(event: any) {
    let value = event.target.value;
    if (this.type == 'textNoNumber') {
      value = value.replace(/\d+/g, '');
      console.log(value)
      this.onChange(value);

      this.displayValue = value;
      event.target.value = value;
      this.controlDir.control?.setValue(value);
      this.controlDir.control?.updateValueAndValidity();

      return value;
    }
  }

  formataNumero(event: any): string {
    const value = event?.target.value;
    // Remove non-numeric characters except .
    let numericValue = value.replace(/[^\d.]/g, '');
    if (numericValue == 0 && this.min) numericValue = this.min?.toString();

    // Allow only one dot in the value
    const dotIndex = numericValue.indexOf('.');
    if (dotIndex !== -1) {
      // Split into two parts and remove any additional dots in the second part
      let integerPart = numericValue.slice(0, dotIndex);
      let decimalPart = numericValue.slice(dotIndex + 1).replace(/\./g, '');
      // Limit the decimal part to 2 digits
      decimalPart = decimalPart.slice(0, this.dotNumber);
      // Combine parts
      numericValue = integerPart + '.' + decimalPart;
    }

    // Add thousand separators to the integer part
    const parts = numericValue.split('.');
    let integerPart = parts[0];
    integerPart = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, ',');

    // Combine integer and decimal parts
    const formattedNumber = parts.length > 1 ? integerPart + '.' + parts[1] : integerPart;
    this.controlDir.control?.setValue(formattedNumber);
    event.target.value = formattedNumber;
    this.controlDir.control?.updateValueAndValidity();
    return formattedNumber;
  }

  thousandSeparator(value: any, separador: string = ".") {
    if (value) {
      let parts = value.toString().split(separador);
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      return parts.join(separador);
    }
    return value;
  }

  parseNumber(value: string): string {
    if (value) {
      let parts = value.split(',');
      value = parts.join('');
      return value;
    }
    return "0";
  }
}
